import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Direction, SegmentEnd } from '@/logic/_infra/_tech';
import { TimeSegment, minuteCalc } from '@/logic/_infra/time'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelengthComponent',
  props: {
    minutes: {},
    stopPropagation: { type: Boolean }
  },
  emits: {
    "click"(d: Direction) {

        return true
    }
},
  setup(__props: any, { emit: __emit }) {


const props = __props


const hours_netto = computed(() => {

    return   Math.floor(props.minutes/60)
})

const minutes_netto = computed(() => {

    return props.minutes % 60
})

const emit = __emit



function click(event:Event, d:Direction){

    if (props.stopPropagation ?? false) event.stopPropagation()
    emit("click", d)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      class: "component",
      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (click($event,'B')), ["stop"]))
    }, _toDisplayString(hours_netto.value) + "h", 1),
    _createTextVNode(" "),
    _createElementVNode("span", {
      class: "component",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (click($event, 'F')), ["stop"]))
    }, _toDisplayString(minutes_netto.value) + "m", 1)
  ], 64))
}
}

})